import {
  Injector, Injectable, Signal, untracked
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import {
  RxReactivityFactory,
  addRxPlugin,
  createRxDatabase
} from 'rxdb/plugins/core';

import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
import { getRxStorageMemory } from 'rxdb/plugins/storage-memory';
import { PROGRAM_SCHEMA } from '../schemas/program.schema';
import { EXPENSE_SCHEMA } from '../schemas/expense.schema';
import { RxTuitionCollections, RxTuitionDatabase } from '../RxDB';


const collectionSettings = {
  ["program"]: {
    schema: PROGRAM_SCHEMA
  },
  ["expense"]:{
    schema: EXPENSE_SCHEMA
  }
};

/**
* creates the database
*/
async function _create(injector: Injector): Promise<RxTuitionDatabase> {

  addRxPlugin(RxDBQueryBuilderPlugin);

  /**
   * Add the Reactivity Factory so that we can get angular Signals
   * instead of observables.
   * @link https://rxdb.info/reactivity.html
   */
  const reactivityFactory: RxReactivityFactory<Signal<any>> = {
      fromObservable(obs, initialValue: any) {
          return untracked(() =>
              toSignal(obs, {
                  initialValue,
                  injector
              })
          );
      }
  }


  const db = await createRxDatabase<RxTuitionCollections>({
      name: "tuition",
      storage: getRxStorageMemory(),
      multiInstance: false,
      reactivity: reactivityFactory

  });

  await db.addCollections(collectionSettings);

  return db as any;
}


let initState: null | Promise<any> = null;;
let DB_INSTANCE: RxTuitionDatabase;

/**
* This is run via APP_INITIALIZER in app.module.ts
* to ensure the database exists before the angular-app starts up
*/
export async function initDatabase(injector: Injector) {
  if (!injector) {
      throw new Error('initDatabase() injector missing');
  }

  /**
   * When server side rendering is used,
   * The database might already be there
   */
  if (!initState) {
      initState = _create(injector).then(db => DB_INSTANCE = db);
  }
  await initState;
}

@Injectable(  {providedIn: 'root'}
)
export class DatabaseService {
  get db(): RxTuitionDatabase {
      return DB_INSTANCE;
  }
}